<template style="height:100%">
  <div class="Review_review">
    <div class="Review_review_top">

      <el-form style="padding:15px;background-color: #fff;" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="创建人">
          <el-input v-model="formInline.creator" placeholder="创建人"></el-input>
        </el-form-item>

        <el-form-item label="帖子内容">
          <el-input v-model="formInline.text" placeholder="帖子内容"></el-input>
        </el-form-item>

        <el-form-item label="类型">
          <el-select v-model="formInline.type" placeholder="类型">
            <el-option label="帖子" value="0"></el-option>
            <el-option label="活动" value="1"></el-option>
            <el-option label="教育" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="审核状态">
          <el-select v-model="formInline.auditStatus" placeholder="审核状态">
            <el-option label="审核中" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核不通过" value="2"></el-option>
          </el-select>
        </el-form-item>



        <el-form-item label="创建时间">
          <el-date-picker v-model="formInline.createTime" type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click="reset()">重置</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="Review_review_nav">
      <el-button type="primary" @click="tg(1)" style="margin:15px">选中通过</el-button>
      <el-button type="primary" @click="tg(2)">选中不通过</el-button>
      <el-table ref="multipleTable" style="width: 98%;margin-left:1%" v-loading="wloading" @selection-change="handleSelectionChange" :row-key="(row) => {return row.commentKey }" :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }">

        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>

        <el-table-column label="序号" width="60px" align="left">
          <template slot-scope="scope" center>
            {{ (msg.pageIndex - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column label="用户头像"  width="80">
          <template slot-scope="scope">
            <img style="width: 50px;height: 50px;border-radius:50%" :src="scope.row.zheadPhotoURL" alt="">
          </template>
        </el-table-column>

        <el-table-column label="评论用户">
          <template slot-scope="scope">
            <span>{{ scope.row.creator }}</span>
          </template>
        </el-table-column>

        <el-table-column label="评论时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>

        <el-table-column label="评论内容">
          <template slot-scope="scope">
            <span>{{ scope.row.text }}</span>
          </template>
        </el-table-column>

        <el-table-column label="审核状态">
          <template slot-scope="scope">
            <span style="color: rgba(0, 136, 255, 1);" v-if="scope.row.auditStatus == 0">审核中</span>
            <span style="color: rgb(54 191 0)" v-if="scope.row.auditStatus == 1">审核通过</span>
            <span style="color: red" v-if="scope.row.auditStatus == 2">审核不通过</span>
          </template>
        </el-table-column>

        <el-table-column label="系统审核状态">
          <template slot-scope="scope">
            <span style="color: rgba(0, 136, 255, 1);" v-if="scope.row.systemAuditStatus == 0">审核中</span>
            <span style="color: rgb(54 191 0)" v-if="scope.row.systemAuditStatus == 1">审核通过</span>
            <span style="color: red" v-if="scope.row.systemAuditStatus == 2">审核不通过</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="looks(scope.row.commentKey,1)" type="text" size="small">
              通过
            </el-button>
            <el-button @click="looks(scope.row.commentKey,2)" type="text" size="small">
              不通过
            </el-button>
          </template>
        </el-table-column>
        
      </el-table>
      <pagination :msgToChild="msg" @send="sendmsg2"></pagination>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination.vue'
export default {
  data() {
    return {
      tableData:[],
      itemKey:[],
      msg:{
        pageIndex:1,
        Counts:10,
      },
      wloading:true,
      formInline: {
        creator: '',
        type: '',
        text: '',
        auditStatus: '',
        createTime: this.Global.querycensus(6),
        pageSize: 10,
      },
    };
  },
  components:{
    pagination
  },
  methods: {
    reset(){
      this.msg.pageIndex = 1
      this.formInline = {
        creator: '',
        type: '',
        text: '',
        auditStatus: '',
        createTime: [],
        pageSize: 10,
      }
      this.load();
    },
    tg(auditStatus){
      this.$Http_Post('/activitymanagement/auditcomment',{commentKeys:this.itemKey,auditStatus:auditStatus}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.$refs.multipleTable.clearSelection();
          this.itemKey = [];
          this.load();
        }
      });
    },
    looks(commentKeys,auditStatus){
      var commentKey = []
      commentKey.push(commentKeys)
      this.$Http_Post('/activitymanagement/auditcomment',{commentKeys:commentKey,auditStatus:auditStatus}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.load();
        }
      });
    },
    sendmsg2(val){//量表点击时子组件传过来值
      this.msg.pageIndex = val.pageIndex;
      this.wloading = true;
      this.load();
    },
    onSubmit(){
      this.msg.pageIndex = 1;
      this.load();
    },
    load(){
      this.$Http_Post('/activitymanagement/getcommentlist',{
        creator:this.formInline.creator,
        type:this.formInline.type,
        text:this.formInline.text,
        auditStatus:this.formInline.auditStatus,
        createTime:this.formInline.createTime,
        pageSize:this.formInline.pageSize,
        pageIndex:this.msg.pageIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0 ) {
          this.tableData = res.Data;
          this.msg.Counts = res.Counts;
          this.wloading = false;
        }
      });
    },
    handleSelectionChange(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].commentKey);
      }
      this.itemKey = lsc;
    },
  },

  created() {

  },

  mounted() {
    this.load()
  }
};
</script>
<style>
  .Review_review{height: 100%;}
  .Review_review_nav{width: 100%;height: calc(100% - 110px);background-color: #fff;margin-top: 15px;overflow: auto;}
</style>